export const BranchesTypes = {
  LOGIN_BRANCHES: "LOGING_BRANCHES",
  SHOW_BRANCHES: "SHOW_BRANCHES",
  ADD_BRANCHES: "ADD_BRANCHES",
  DELETE_BRANCHES: "DELETE_BRANCHES",
  DELETE_BRANCHES_SMS: "DELETE_BRANCHES_SMS",
};
